export enum NotificationTypeEnum {
  Error = 'error',
  Success = 'success',
  Info = 'info',
  Warn = 'warning',
}
